import { render, staticRenderFns } from "./boardcastIdolBigViewList.vue?vue&type=template&id=4c61df08&scoped=true"
import script from "./boardcastIdolBigViewList.vue?vue&type=script&lang=ts"
export * from "./boardcastIdolBigViewList.vue?vue&type=script&lang=ts"
import style0 from "./boardcastIdolBigViewList.vue?vue&type=style&index=0&id=4c61df08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61df08",
  null
  
)

export default component.exports